import React from 'react';
import { Tag } from 'antd';
import { IconTextButton, Typography } from 'ui-lib';
import { IRecordPickerProps } from './record-picker.types';
import { RecordPickerModal } from './record-picker-modal';
import { getRecordKey } from './selectable-table';
import css from './record-picker.css';

export const RecordPicker = <T,>(props: IRecordPickerProps<T>): JSX.Element => {
    const { renderRecordTag, value = [], onChange, ...tableProps } = props;
    const [isModalVisible, setIsModalVisible] = React.useState(false);
    const [modalKey, setModalKey] = React.useState(0);
    const name = props.selectionType === 'single' ? 'record' : 'records';

    const openModal = () => {
        setModalKey((key) => key + 1);
        setIsModalVisible(true);
    };

    const removeRecord = (record: T) => onChange?.(value.filter((item) => item !== record));

    return (
        <div className={css['record-picker']}>
            <div className={css['record-picker-values']}>
                {value.length === 0 ? (
                    <Typography.Text type='secondary' italic={true}>No record selected</Typography.Text>
                ) : (
                    value.map((record) => (
                        <Tag
                            key={getRecordKey(record, props.rowKey)}
                            closable={true}
                            onClose={(event) => {
                                event.preventDefault();
                                removeRecord(record);
                            }}
                        >
                            {renderRecordTag(record)}
                        </Tag>
                    ))
                )}
            </div>
            <IconTextButton
                type='link'
                className={css['record-picker-link']}
                label={`${value.length > 0 ? 'Change' : 'Select'} ${name}`}
                onClick={openModal}
            />
            <RecordPickerModal
                {...tableProps}
                key={modalKey}
                isVisible={isModalVisible}
                title={`Select ${name}`}
                initialValue={value}
                onCancel={() => setIsModalVisible(false)}
                onConfirm={(records) => {
                    onChange?.(records);
                    setIsModalVisible(false);
                }}
            />
        </div>
    );
};
